import { useAlertStore } from '@/store/alert'
import { appleLogin, appleRegister } from '@/service/login'
import { RegistrationType } from '@/types/member'
import type { SocialLoginProvider } from '@/types/socialLogin'

export function createAppleProvider(): SocialLoginProvider {
  const alertStore = useAlertStore()
  const { t } = useI18n()

  return {
    type: 'apple',
    registrationType: RegistrationType.APPLE,
    login: ctx => appleLogin(ctx.token, ctx.authorizationCode || ''),
    register: (ctx, param) =>
      appleRegister(ctx.token, ctx.authorizationCode || '', {
        ...(ctx.name !== undefined && { name: ctx.name }),
        ...param,
      }),
    resolveRedirectUrl: () => undefined,
    onError: (_ctx, error: any) => {
      console.error('appleProvider: error', error)
      alertStore.error(error?.data?.message || t('member_auth_login_failed'))
    },
  }
}
